/**
 * Chair Dinkum - Herman Miller warranty selector + cart association guard (HM4B, 8 Oct 2026)
 * - PDP: 12-month (default, line property) / 12-year Extended Warranty (adds a linked $200 add-on line).
 * - Cart guard (all pages): keeps the add-on aligned to its chair, removes orphans, keeps the chair
 *   "Warranty" property consistent and records _hm_wty_check = ok | mismatch as a cart attribute.
 * Theme JavaScript is not server-side enforcement; Shopify Flow flags anomalous orders.
 */
(function () {
  'use strict';
  var ADDON_HANDLE = 'chair-dinkum-12-year-extended-warranty-herman-miller';
  var STD = '12-month Chair Dinkum warranty (included) · HM-12M-1';
  var EXT = '12-year Chair Dinkum Extended Warranty · HM-12Y-1';

  function money(cents) {
    try { return window.theme.Currency.formatMoney(cents, window.theme.settings.moneyFormat); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function variantMap(w) {
    try { return JSON.parse(w.querySelector('[data-cd-wty-variants]').textContent); } catch (e) { return {}; }
  }
  function currentVariant(form) { var i = form.querySelector('[name="id"]'); return i ? i.value : null; }
  function qtyOf(form) {
    var q = form.querySelector('[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return n > 0 ? n : 1;
  }
  function updateTotal(w) {
    var form = w.closest('form'); if (!form) return;
    var span = form.querySelector('[data-cd-wty-total]'); if (!span) return;
    var ext = w.querySelector('[data-cd-wty-ext]');
    if (ext && ext.checked) {
      var v = variantMap(w)[currentVariant(form)];
      var p = parseInt(w.getAttribute('data-ext-price') || '0', 10);
      if (v) { span.textContent = ' · ' + money((v.p + p) * qtyOf(form)); return; }
    }
    span.textContent = '';
  }
  function resetAll() {
    var ws = document.querySelectorAll('[data-cd-wty]');
    for (var k = 0; k < ws.length; k++) {
      var s = ws[k].querySelector('[data-cd-wty-std]'); if (s) s.checked = true;
      var e = ws[k].querySelector('[data-cd-wty-ext]'); if (e) e.checked = false;
      updateTotal(ws[k]);
    }
  }
  function showErr(form, msg) {
    var el = form.querySelector('.cd-wty__err');
    if (!el) { el = document.createElement('p'); el.className = 'cd-wty__err'; el.setAttribute('role', 'alert'); el.style.cssText = 'color:#a33;font-size:.9em;margin:8px 0 0'; var w = form.querySelector('[data-cd-wty]'); (w || form).appendChild(el); }
    el.textContent = msg;
  }

  // Never persist the paid choice: reset on load and on back/forward cache restores.
  document.addEventListener('DOMContentLoaded', resetAll);
  window.addEventListener('pageshow', resetAll);
  // Quick-shop modals inject forms later: reset any new selector when it appears.
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType === 1 && (n.matches && n.matches('[data-cd-wty]') || n.querySelector && n.querySelector('[data-cd-wty]'))) { resetAll(); return; }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('change', function (e) {
    var form = e.target && e.target.closest && e.target.closest('form'); if (!form) return;
    var w = form.querySelector('[data-cd-wty]'); if (w) setTimeout(function () { updateTotal(w); }, 60);
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var o = t.closest('[data-cd-wty-open]');
    if (o) {
      e.preventDefault();
      var d = o.closest('[data-cd-wty]').querySelector('dialog');
      if (d && d.showModal) { d.showModal(); } else if (d) { d.setAttribute('open', ''); }
      return;
    }
    var c = t.closest('[data-cd-wty-close]');
    if (c) { e.preventDefault(); var d2 = c.closest('dialog'); if (d2 && d2.close) d2.close(); else if (d2) d2.removeAttribute('open'); return; }
    if (t.tagName === 'DIALOG' && t.classList.contains('cd-wty__dlg') && t.close) t.close();
  });

  // 12-year: add the linked add-on and the chair in one request (capture phase, before the theme handler).
  document.addEventListener('submit', function (e) {
    var form = e.target; if (!form || !form.querySelector) return;
    var w = form.querySelector('[data-cd-wty]'); if (!w) return;
    var ext = w.querySelector('[data-cd-wty-ext]'); if (!ext || !ext.checked) return;
    var vid = currentVariant(form); var addon = w.getAttribute('data-ext-variant');
    if (!vid || !addon) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var qty = qtyOf(form);
    var vm = variantMap(w); var vt = (vm[vid] && vm[vid].t) || '';
    var title = w.getAttribute('data-product-title') + (vt && vt !== 'Default Title' ? ' – ' + vt : '');
    var g = 'w' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    var btn = form.querySelector('[name="add"]'); if (btn) btn.classList.add('btn--loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [
        { id: parseInt(addon, 10), quantity: qty, properties: { 'For': title, '_wty': g, '_chair_variant': String(vid), '_terms': 'HM-12Y-1' } },
        { id: parseInt(vid, 10), quantity: qty, properties: { 'Warranty': EXT, '_wty': g } }
      ] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (btn) btn.classList.remove('btn--loading');
        if (!res.ok) { showErr(form, (res.j && (res.j.description || res.j.message)) || 'Sorry, this could not be added to the cart.'); return; }
        if (window.theme && window.theme.settings && window.theme.settings.cartType === 'page') { window.location = '/cart'; return; }
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: res.j } }));
      })
      .catch(function () { if (btn) btn.classList.remove('btn--loading'); showErr(form, 'Sorry, this could not be added to the cart. Please try again.'); });
  }, true);

  // ---------- cart guard ----------
  function props(i) { return i.properties || {}; }
  function isAddon(i) { return i.handle === ADDON_HANDLE || (i.product_type === 'Warranty' && i.vendor === 'Chair Dinkum'); }
  function isHM(i) { return i.vendor === 'Herman Miller' && !isAddon(i); }
  function plan(cart) {
    var items = cart.items || [], chairs = {}, seen = {};
    items.forEach(function (i) { var g = props(i)._wty; if (isHM(i) && g) (chairs[g] = chairs[g] || []).push(i); });
    var ops = [];
    items.forEach(function (i) {
      if (!isAddon(i)) return;
      var g = props(i)._wty, ch = g ? chairs[g] : null;
      if (!ch || seen[g]) { ops.push({ id: i.key, quantity: 0 }); return; }
      seen[g] = true;
      var want = ch.reduce(function (s, c) { return s + c.quantity; }, 0);
      if (i.quantity !== want) ops.push({ id: i.key, quantity: want });
    });
    items.forEach(function (i) {
      if (!isHM(i)) return;
      var p = props(i), g = p._wty;
      if (g && !seen[g]) ops.push({ id: i.key, quantity: i.quantity, properties: { 'Warranty': STD } });
      else if (!g && p.Warranty !== STD) ops.push({ id: i.key, quantity: i.quantity, properties: { 'Warranty': STD } });
      else if (g && p.Warranty !== EXT) ops.push({ id: i.key, quantity: i.quantity, properties: { 'Warranty': EXT, '_wty': g } });
    });
    return ops;
  }
  function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }
  var running = false;
  function guard() {
    if (running) return; running = true;
    var changed = false;
    function step(n) {
      return getCart().then(function (cart) {
        var relevant = (cart.items || []).some(function (i) { return isHM(i) || isAddon(i); });
        var ops = plan(cart);
        if (ops.length && n < 8) { changed = true; return post('/cart/change.js', ops[0]).then(function () { return step(n + 1); }); }
        var want = !relevant ? null : (ops.length ? 'mismatch' : 'ok');
        var have = (cart.attributes || {})._hm_wty_check || null;
        if (want && want !== have) return post('/cart/update.js', { attributes: { '_hm_wty_check': want } });
      });
    }
    step(0).then(function () {
      running = false;
      if (changed) document.dispatchEvent(new CustomEvent('cart:build'));
    }).catch(function () { running = false; });
  }
  document.addEventListener('DOMContentLoaded', function () { setTimeout(guard, 300); });
  document.addEventListener('cart:updated', function () { setTimeout(guard, 150); });
  document.addEventListener('ajaxProduct:added', function () { setTimeout(guard, 500); });
})();
